import React from 'react';
import classnames from 'classnames';

export default class CollapsibleMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: true,
    };

    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    const contentClassName = classnames('menu-collapsible-content', {
      close: !this.state.isOpen,
    });

    return (
      <div className='menu-collapsible'>
        <div className='collapsible-panel-arrow-title-bar' onClick={this.handleToggle}>
          <i className={'fa ' + (this.state.isOpen ? 'fa-angle-down' : 'fa-angle-right')} />
          <h3>{this.props.title}</h3>
          {this.props.plan === 'pro' && <span className='pro-ribbon push-left'>Pro</span>}
        </div>
        <div className={contentClassName}>{this.props.children}</div>
      </div>
    );
  }
}

CollapsibleMenu.propTypes = {
  children: React.PropTypes.node,
  title: React.PropTypes.string.isRequired,
  plan: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/ui/properties-panel/collapsible-menu.jsx